import { Loading } from "../../Loading/String/Loading";
import { downloadFile } from "../../../apis/apiExports";
import { useState, useEffect } from "react";
import "./Exports.scss";
import { SectionHeader } from '../../GlobalComponents/SectionHeader/SectionHeader';
import Icon from "../../Icon/Icon";
import { EGButton } from '../../MainComponents/Button/EGButton/EGButton';
import { useTheme } from "@mui/material";
import { Exportables } from "./ExportsList";
import ReportsTable from "./components/ReportsTable"
import SectionDescription from "./components/SectionDescription";
import SectionTabs from "./components/SectionTabs";
import { useTranslation } from "react-i18next";
import { useExportablesFiles } from "./hooks";
import DetailFileModal from './components/DetailFileModal';
import { getReports, getInvestigation } from '../../../apis' 


const ExportablesRefactor = () => {
  const {
    selectedFileState: [selectedFile, setSelectedFile],
    selectedSectionState: [selectedSection, setSelectedSection],
    exportablesFiles,
    lastExportablesFiles,
    meta,
    updateFiles,
    updateLastFiles,
    updateAll,
    deleteFile,
    updateFromComponent,
    areThereFiles,
  } = useExportablesFiles();
  const [showDetailFileModal, setShowDetailFileModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedMode, setSelectedMode] = useState('info');
  const [isLoading, setIsLoading] = useState(true);
  const [t] = useTranslation("exports");
  const theme = useTheme();

  const tabsData = [
    {
      code: 'all',
      title: t("tabs.all"),
      callback: () => setSelectedSection('all'),
    },
    {
      code: 'report',
      title: t("tabs.report"),
      callback: () => setSelectedSection('report'),
    },
    {
      code: 'involved',
      title: t("tabs.involved"),
      callback: () => setSelectedSection('involved'),
    },
    {
      code: 'investigation',
      title: t("tabs.investigation"),
      callback: () => setSelectedSection('investigation'),
    },
  ]

  const sectionsInformation = {
    'all': {
      'title': t("section.all"),
      'content': <p>{t("descriptions.all")} <a href="" style={{ 'color': `${theme.palette.primary.main}`, 'textDecoration': 'none' }}>{t("section.read_more")}</a></p>,
    },
    'report': {
      'title': t("section.report"),
      'content': <p>{t("descriptions.report")} <a href="" style={{ 'color': `${theme.palette.primary.main}`, 'textDecoration': 'none' }}>{t("section.read_more")}</a></p>,
    },
    'involved': {
      'title': t("section.involved"),
      'content': <p>{t("descriptions.involved")} <a href="" style={{ 'color': `${theme.palette.primary.main}`, 'textDecoration': 'none' }}>{t("section.read_more")}</a></p>,
    },
    'investigation': {
      'title': t("section.investigation"),
      'content': <p>{t("descriptions.investigation")} <a href="" style={{ 'color': `${theme.palette.primary.main}`, 'textDecoration': 'none' }}>{t("section.read_more")}</a></p>,
    },
  };

  // Functions
  const handledownloadFile = async (file) => {
    try {
      const response = await downloadFile(file.alias);
      if (response !== undefined) {
        window.open(response.data.file, "_blank");
      }
    } catch (err) {
      console.warn(err)
    }
  };

  const handledeleteFile = async () => {
    await deleteFile(selectedFile.alias);
    setShowDetailFileModal(false);
  };

  const openModalFromDetail = (file, part) => {
    const selFile = { ...file };
    selFile['template_name'] = file.template__template_name
    selFile['template_alias'] = file.template__alias
    setSelectedFile(selFile);
    setSelectedMode(part);
    setShowDetailFileModal(true);
  };

  // JSX elements
  const icon = <Icon float="left" width="48" height="48" name={'bold_chart_square'} />;
  const button = <EGButton
    label={t("header.button")}
    color={'primary'}
    position={'end'}
    onClick={() => {
      setShowCreateModal(true)
    }}
    size={'medium'}
    variant="outlined"
  />

  useEffect(() => {
    const fetchReports = async () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      try {
        const firstReport = await getReports({ position: 'first' }, null);
        if (firstReport) {
          localStorage.setItem('first_created_at', `${firstReport.created_at}`); // Fisrt Report Created at
        }
      } catch (error) {
        console.error('Error fetching first report:', error);
      }
    };

    fetchReports();
  }, []);

  useEffect(() => {
    if (showDetailFileModal) setShowDetailFileModal(false);
  }, [lastExportablesFiles]);

  useEffect(() => {
    updateFromComponent({ selectedSection });
  }, [selectedSection]);

  return (
    <>
      <div className={`all-exports-page`}>
        {
          !isLoading ? (
            <>
              {/* Detail file modal */}
              <DetailFileModal
                showComponent={showDetailFileModal}
                setShowComponent={setShowDetailFileModal}
                downloadFunction={handledownloadFile}
                deleteFunction={handledeleteFile}
                file={selectedFile}
                setSelectedFile={setSelectedFile}
                selectedMode={selectedMode}
                setSelectedMode={setSelectedMode}
              />
              {/* Header */}
              <SectionHeader
                title={t("header.title")}
                subtitle={t("header.subtitle")}
                icon={icon}
                component={button}
              />
              {/* 3 exportables files */}
              <Exportables
                data={lastExportablesFiles}
                areThereFiles={areThereFiles}
                deleteFunction={deleteFile}
                updateFunctions={{ updateFiles, updateLastFiles, updateAll }}
                openModalFromDetail={openModalFromDetail}
                selectedSection={selectedSection}
                showCreateModal={showCreateModal}
                setShowCreateModal={setShowCreateModal}
              />
              {/* Description */}
              <SectionDescription
                title={sectionsInformation[selectedSection].title}
                content={sectionsInformation[selectedSection].content}
                display={areThereFiles}
              />
              {/* Tabs */}
              <SectionTabs
                selectedSection={selectedSection}
                data={tabsData}
                display={areThereFiles}
              />
              {/* List */}
              {areThereFiles && (
                <div style={{ 'marginTop': '30px' }}>
                  {
                    selectedSection === 'investigation' ? 
                    (
                      <h2 style={{ textAlign: 'center', margin: '80px' }}>En construcción</h2>
                    ) :
                    (
                      <ReportsTable
                        reports={exportablesFiles}
                        selectedFile={selectedFile}
                        setSelectedFile={setSelectedFile}
                        setShowDetailFileModal={setShowDetailFileModal}
                        downloadFunction={handledownloadFile}
                        metadata={meta}
                        updateFromPaginator={updateFromComponent}
                      />
                    )
                  }

                </div>
              )}
            </>
          ) : (
            <div className="dyTheme1 dyBorder1 p-sm-4 reportsTable">
              <Loading />
            </div>
          )
        }
      </div>
    </>
  )
};

export default ExportablesRefactor;